import { render, staticRenderFns } from "./GlobalOfferScraper.vue?vue&type=template&id=4db86f64&scoped=true&"
import script from "./GlobalOfferScraper.vue?vue&type=script&lang=js&"
export * from "./GlobalOfferScraper.vue?vue&type=script&lang=js&"
import style0 from "./GlobalOfferScraper.vue?vue&type=style&index=0&id=4db86f64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db86f64",
  null
  
)

export default component.exports